<template>
    <div>
        <div class="flex items-center p-4">
            <span class="mr-4 scale-150 cursor-pointer" @click="$emit('close')">
                <svg-icon icon="arrow-small-left" width="20px" height="20px" />
            </span>
            <strong class="mb-0">
                <b v-if="onlyMobileVisible">{{ localizations[lang].share.copyShare }}</b>
                <b v-else>{{ localizations[lang].share.scanQr }}</b>
            </strong>
        </div>
        <ol v-if="onlyMobileVisible">
            <li>
                <label for="share-link">{{ localizations[lang].share.copyLink }}</label>
                <div class="relative mb-4 flex content-center pr-5">
                    <input
                        id="share-link"
                        type="text"
                        class="w-full truncate rounded-l border border-theme-button-border bg-theme-button-bg px-2 text-theme-title"
                        :value="urlForShare"
                        readonly
                    />
                    <div>
                        <button
                            class="linearButton inline-flex rounded-r border-l-0"
                            type="button"
                            @click="copyUrlForShare"
                        >
                            <svg-icon icon="baseline-link-24px"></svg-icon>
                        </button>
                    </div>
                    <span
                        v-if="isCopySuccessful"
                        class="absolute right-[calc(100%/2.2)] z-50 mt-1 rounded bg-theme-text px-2.5 py-1 text-theme-bg shadow"
                    >
                        {{ localizations[lang].share.copied }}
                    </span>
                </div>
            </li>
            <transition name="fade-list">
                <div v-if="canOpenWeChat">
                    <li class="py-4">
                        <a
                            href="weixin://"
                            target="_blank"
                            class="linearButton inline-flex hover:text-inherit hover:no-underline focus:text-inherit focus:no-underline"
                            @click="openWeChat"
                        >
                            <span>
                                {{
                                    openingWeChat
                                        ? localizations[lang].share.openingWechat
                                        : localizations[lang].share.openWechat
                                }}
                            </span>
                        </a>
                    </li>
                    <li class="mt-3 pb-4">{{ localizations[lang].share.sendCopiedUrl }}</li>
                </div>
            </transition>
        </ol>
        <QrShare v-else :url-for-share="urlForShare" :iframe-title="localizations[lang].share.qrCodeTitle" />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import QrShare from './QrShare.vue';

export default {
    components: {
        QrShare,
    },
    props: {
        urlForShare: {
            required: true,
            type: String,
        },
    },
    emits: ['close'],
    data() {
        return {
            shareWithLocation: true,
            isCopySuccessful: false,
            canOpenWeChat: false,
            openingWeChat: false,
        };
    },
    computed: {
        ...mapState(['issue', 'localizations', 'lang']),
        ...mapGetters(['onlyMobileVisible']),
    },
    methods: {
        ...mapActions(['copyToClipBoard']),
        copyUrlForShare() {
            this.copyToClipBoard(this.urlForShare);
            this.isCopySuccessful = true;
            this.canOpenWeChat = true;
            setTimeout(() => {
                this.isCopySuccessful = false;
            }, 2000);
        },
        openWeChat() {
            this.openingWeChat = true;
            setTimeout(() => {
                this.openingWeChat = false;
            }, 5000);

            this.trackEvent({
                action: 'share',
                issue_id: this.issue.id,
                trigger: 'click',
                source: 'volpe:share-wechat',
            });
        },
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
